var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content", attrs: { type: "primary" } },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "410015204",
                reset: true,
                "show-simple": false,
                "expand-adv": true,
                "auto-init": true,
                "custom-search-items": _vm.customSearchItems,
                no: "1"
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "2" },
                      on: {
                        click: function($event) {
                          return _vm.sendOfficeBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SettlementNotice")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "3" },
                      on: {
                        click: function($event) {
                          return _vm.viewDetailBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ViewDetail")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "4" },
                      on: {
                        click: function($event) {
                          return _vm.sendDLClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NotifyHq")))]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "410015204",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "410015204",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.billNoticeResultWindow.visible
        ? _c("bill-notice-result-window", {
            attrs: {
              visible: _vm.billNoticeResultWindow.visible,
              "select-items": _vm.billNoticeResultWindow.selectItems
            },
            on: {
              close: function($event) {
                _vm.billNoticeResultWindow.visible = false
              },
              refresh: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.billActualAmountDetailWindow.visible
        ? _c("bill-actual-amount-detail-window", {
            attrs: {
              visible: _vm.billActualAmountDetailWindow.visible,
              "actual-amount": _vm.billActualAmountDetailWindow.actualAmount
            },
            on: {
              close: function($event) {
                _vm.billActualAmountDetailWindow.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }